/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../banking/common';
import './model/bank_account_model';
import '../../common/location';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bankingaccounts": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "ListBankAccountsRequest": {
                    "fields": {
                      "squareTokenAssociation": {
                        "type": ".squareup.banking.Owner",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "accountProduct": {
                        "type": ".squareup.bankingaccounts.external.model.BankAccount.AccountProductType",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "limit": {
                        "type": "int32",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": 50
                        }
                      },
                      "cursor": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  },
                  "ListBankAccountsResponse": {
                    "fields": {
                      "bankAccounts": {
                        "type": ".squareup.bankingaccounts.external.model.BankAccount",
                        "id": 1,
                        "rule": "repeated"
                      },
                      "error": {
                        "type": ".squareup.bankingaccounts.external.service.ListBankAccountsResponse.Warning",
                        "id": 2,
                        "rule": "repeated"
                      },
                      "cursor": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Warning": {
                        "fields": {
                          "code": {
                            "type": ".squareup.bankingaccounts.external.service.ListBankAccountsResponse.Warning.Code",
                            "id": 1,
                            "rule": "optional"
                          },
                          "category": {
                            "type": ".squareup.bankingaccounts.external.service.ListBankAccountsResponse.Warning.Category",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Code": {
                            "values": {
                              "UNKNOWN_CODE_DO_NOT_USE": 0,
                              "SAVINGS_UNAVAILABLE": 1,
                              "MERCHANT_NOT_FOUND": 2,
                              "UNIT_NOT_FOUND": 3,
                              "INVALID_CURSOR": 4,
                              "INVALID_OWNER_TYPE": 5,
                              "NOT_ACCOUNT_OWNER": 6
                            }
                          },
                          "Category": {
                            "values": {
                              "UNKNOWN_CATEGORY_DO_NOT_USE": 0,
                              "API_ERROR": 1,
                              "INVALID_REQUEST_ERROR": 2
                            }
                          }
                        }
                      }
                    }
                  },
                  "CreateDepositBankAccountRequest": {
                    "fields": {
                      "idempotenceKey": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "squareTokenAssociation": {
                        "type": ".squareup.banking.Owner",
                        "id": 2,
                        "rule": "optional"
                      },
                      "usSavingsParams": {
                        "type": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest.UsSavingsParams",
                        "id": 3
                      },
                      "usCheckingParams": {
                        "type": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest.UsCheckingParams",
                        "id": 4
                      },
                      "caFoldersParams": {
                        "type": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest.CaFoldersParams",
                        "id": 5
                      },
                      "caSquareCardParams": {
                        "type": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest.CaSquareCardParams",
                        "id": 6
                      },
                      "gbSquareCardParams": {
                        "type": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest.GbSquareCardParams",
                        "id": 7
                      }
                    },
                    "nested": {
                      "UsSavingsParams": {
                        "fields": {
                          "subjectToBackupWithholding": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "UsCheckingParams": {
                        "fields": {}
                      },
                      "CaFoldersParams": {
                        "fields": {}
                      },
                      "CaSquareCardParams": {
                        "fields": {
                          "shippingAddress": {
                            "type": ".squareup.common.location.GlobalAddress",
                            "id": 1,
                            "rule": "optional"
                          },
                          "customizationToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "GbSquareCardParams": {
                        "fields": {
                          "shippingAddress": {
                            "type": ".squareup.common.location.GlobalAddress",
                            "id": 1,
                            "rule": "optional"
                          },
                          "customizationToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "product_params": {
                        "oneof": ["usSavingsParams", "usCheckingParams", "caFoldersParams", "caSquareCardParams", "gbSquareCardParams"]
                      }
                    }
                  },
                  "CreateDepositBankAccountResponse": {
                    "fields": {
                      "success": {
                        "type": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountResponse.Success",
                        "id": 1
                      },
                      "error": {
                        "type": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountResponse.Error",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Success": {
                        "fields": {
                          "account": {
                            "type": ".squareup.bankingaccounts.external.model.DepositAccount",
                            "id": 1,
                            "rule": "optional"
                          },
                          "cardDetails": {
                            "type": ".squareup.bankingaccounts.external.model.CardDetails",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Error": {
                        "fields": {
                          "code": {
                            "type": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountResponse.Error.Code",
                            "id": 1,
                            "rule": "optional"
                          },
                          "log": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "category": {
                            "type": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountResponse.Error.Category",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Code": {
                            "values": {
                              "UNKNOWN_ERROR_DO_NOT_USE": 0,
                              "MERCHANT_NOT_FOUND": 1,
                              "UNIT_NOT_FOUND": 2,
                              "UPSTREAM_SERVICE_DOWN": 3,
                              "DENIED": 4,
                              "CHALLENGED": 5,
                              "INVALID_OWNER_TYPE": 6,
                              "NOT_ACCOUNT_OWNER": 7,
                              "INVALID_ACCOUNT_PRODUCT": 8,
                              "INCOMPLETE_IDV": 9,
                              "INVALID_PRODUCT_PARAMS": 10,
                              "ACCOUNT_LIMIT_REACHED": 11
                            }
                          },
                          "Category": {
                            "values": {
                              "UNKNOWN_CATEGORY_DO_NOT_USE": 0,
                              "API_ERROR": 1,
                              "INVALID_REQUEST_ERROR": 2,
                              "UNAUTHORIZED": 3
                            }
                          }
                        }
                      },
                      "result": {
                        "oneof": ["success", "error"]
                      }
                    }
                  },
                  "GetBankAccountRequest": {
                    "fields": {
                      "includeFullDetails": {
                        "type": "bool",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      },
                      "bankingAccountId": {
                        "type": "string",
                        "id": 1
                      },
                      "bankcBalanceId": {
                        "type": "string",
                        "id": 2
                      }
                    },
                    "nested": {
                      "id": {
                        "oneof": ["bankingAccountId", "bankcBalanceId"]
                      }
                    }
                  },
                  "GetBankAccountResponse": {
                    "fields": {
                      "bankAccount": {
                        "type": ".squareup.bankingaccounts.external.model.BankAccount",
                        "id": 1
                      },
                      "error": {
                        "type": ".squareup.bankingaccounts.external.service.GetBankAccountResponse.Error",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Error": {
                        "fields": {
                          "code": {
                            "type": ".squareup.bankingaccounts.external.service.GetBankAccountResponse.Error.Code",
                            "id": 1,
                            "rule": "optional"
                          },
                          "category": {
                            "type": ".squareup.bankingaccounts.external.service.GetBankAccountResponse.Error.Category",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Code": {
                            "values": {
                              "UNKNOWN_CODE_DO_NOT_USE": 0,
                              "SAVINGS_UNAVAILABLE": 1,
                              "UNIT_NOT_FOUND": 2,
                              "INVALID_OWNER_TYPE": 3,
                              "NO_REQUEST_ID_INCLUDED": 4,
                              "ACCOUNT_NOT_FOUND": 5,
                              "INTERNAL_SERVICE_OR_UPSTREAM_ERROR": 6
                            }
                          },
                          "Category": {
                            "values": {
                              "UNKNOWN_CATEGORY_DO_NOT_USE": 0,
                              "API_ERROR": 1,
                              "INVALID_REQUEST_ERROR": 2
                            }
                          }
                        }
                      },
                      "account": {
                        "oneof": ["bankAccount", "error"]
                      }
                    }
                  },
                  "GetActiveBankAccountForUnitRequest": {
                    "fields": {
                      "squareTokenAssociation": {
                        "type": ".squareup.banking.Owner",
                        "id": 1,
                        "rule": "optional"
                      },
                      "includeFullDetails": {
                        "type": "bool",
                        "id": 2,
                        "rule": "optional",
                        "options": {
                          "default": false
                        }
                      }
                    }
                  },
                  "GetActiveBankAccountForUnitResponse": {
                    "fields": {
                      "bankAccount": {
                        "type": ".squareup.bankingaccounts.external.model.BankAccount",
                        "id": 1
                      },
                      "error": {
                        "type": ".squareup.bankingaccounts.external.service.GetActiveBankAccountForUnitResponse.Error",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Error": {
                        "fields": {
                          "code": {
                            "type": ".squareup.bankingaccounts.external.service.GetActiveBankAccountForUnitResponse.Error.Code",
                            "id": 1,
                            "rule": "optional"
                          },
                          "category": {
                            "type": ".squareup.bankingaccounts.external.service.GetActiveBankAccountForUnitResponse.Error.Category",
                            "id": 2,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Code": {
                            "values": {
                              "UNKNOWN_CODE_DO_NOT_USE": 0,
                              "ACCOUNT_NOT_FOUND": 1,
                              "INVALID_OWNER_TYPE": 2,
                              "UPSTREAM_SERVICE_DOWN": 3
                            }
                          },
                          "Category": {
                            "values": {
                              "UNKNOWN_CATEGORY_DO_NOT_USE": 0,
                              "API_ERROR": 1,
                              "INVALID_REQUEST_ERROR": 2
                            }
                          }
                        }
                      },
                      "account": {
                        "oneof": ["bankAccount", "error"]
                      }
                    }
                  },
                  "CloseDepositBankAccountRequest": {
                    "fields": {
                      "accountId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "comment": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  },
                  "CloseDepositBankAccountResponse": {
                    "fields": {
                      "bankAccount": {
                        "type": ".squareup.bankingaccounts.external.model.BankAccount",
                        "id": 1
                      },
                      "error": {
                        "type": ".squareup.bankingaccounts.external.service.CloseDepositBankAccountResponse.Error",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Error": {
                        "fields": {
                          "code": {
                            "type": ".squareup.bankingaccounts.external.service.CloseDepositBankAccountResponse.Error.Code",
                            "id": 1,
                            "rule": "optional"
                          },
                          "detail": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "category": {
                            "type": ".squareup.bankingaccounts.external.service.CloseDepositBankAccountResponse.Error.Category",
                            "id": 3,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Code": {
                            "values": {
                              "UNKNOWN_ERROR_DO_NOT_USE": 0,
                              "ACCOUNT_NOT_FOUND": 1
                            }
                          },
                          "Category": {
                            "values": {
                              "UNKNOWN_CATEGORY_DO_NOT_USE": 0,
                              "API_ERROR": 1,
                              "INVALID_REQUEST_ERROR": 2
                            }
                          }
                        }
                      },
                      "account": {
                        "oneof": ["bankAccount", "error"]
                      }
                    }
                  },
                  "BankAccountsServiceExternal": {
                    "methods": {
                      "CreateDepositBankAccount": {
                        "requestType": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest",
                        "responseType": ".squareup.bankingaccounts.external.service.CreateDepositBankAccountResponse"
                      },
                      "ListBankAccounts": {
                        "requestType": ".squareup.bankingaccounts.external.service.ListBankAccountsRequest",
                        "responseType": ".squareup.bankingaccounts.external.service.ListBankAccountsResponse"
                      },
                      "GetBankAccount": {
                        "requestType": ".squareup.bankingaccounts.external.service.GetBankAccountRequest",
                        "responseType": ".squareup.bankingaccounts.external.service.GetBankAccountResponse"
                      },
                      "GetActiveBankAccountForUnit": {
                        "requestType": ".squareup.bankingaccounts.external.service.GetActiveBankAccountForUnitRequest",
                        "responseType": ".squareup.bankingaccounts.external.service.GetActiveBankAccountForUnitResponse"
                      },
                      "CloseDepositBankAccount": {
                        "requestType": ".squareup.bankingaccounts.external.service.CloseDepositBankAccountRequest",
                        "responseType": ".squareup.bankingaccounts.external.service.CloseDepositBankAccountResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.ListBankAccountsRequest && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.ListBankAccountsResponse && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.ListBankAccountsResponse?.nested?.Warning && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.ListBankAccountsResponse?.nested?.Warning?.nested?.Code && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.ListBankAccountsResponse?.nested?.Warning?.nested?.Category && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountRequest && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountRequest?.nested?.UsSavingsParams && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountRequest?.nested?.UsCheckingParams && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountRequest?.nested?.CaFoldersParams && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountRequest?.nested?.CaSquareCardParams && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountRequest?.nested?.GbSquareCardParams && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountResponse && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountResponse?.nested?.Success && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountResponse?.nested?.Error?.nested?.Code && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CreateDepositBankAccountResponse?.nested?.Error?.nested?.Category && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.GetBankAccountRequest && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.GetBankAccountResponse && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.GetBankAccountResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.GetBankAccountResponse?.nested?.Error?.nested?.Code && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.GetBankAccountResponse?.nested?.Error?.nested?.Category && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.GetActiveBankAccountForUnitRequest && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.GetActiveBankAccountForUnitResponse && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.GetActiveBankAccountForUnitResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.GetActiveBankAccountForUnitResponse?.nested?.Error?.nested?.Code && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.GetActiveBankAccountForUnitResponse?.nested?.Error?.nested?.Category && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CloseDepositBankAccountRequest && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CloseDepositBankAccountResponse && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CloseDepositBankAccountResponse?.nested?.Error && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CloseDepositBankAccountResponse?.nested?.Error?.nested?.Code && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.CloseDepositBankAccountResponse?.nested?.Error?.nested?.Category && !$root.nested?.squareup?.nested?.bankingaccounts?.nested?.external?.nested?.service?.nested?.BankAccountsServiceExternal) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListBankAccountsRequest @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 17:1
 */
export const ListBankAccountsRequest = $root.lookupType('squareup.bankingaccounts.external.service.ListBankAccountsRequest');
fixType(ListBankAccountsRequest, {
  squareTokenAssociation: {
    required: true
  }
});
Builder.createAndAttachToType(ListBankAccountsRequest);
/**
 * SOURCE ListBankAccountsResponse @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 28:1
 */
export const ListBankAccountsResponse = $root.lookupType('squareup.bankingaccounts.external.service.ListBankAccountsResponse');
fixType(ListBankAccountsResponse);
Builder.createAndAttachToType(ListBankAccountsResponse);
/**
 * SOURCE Warning @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 38:3
 */
ListBankAccountsResponse.Warning = $root.lookupType('squareup.bankingaccounts.external.service.ListBankAccountsResponse.Warning');
fixType(ListBankAccountsResponse.Warning);
Builder.createAndAttachToType(ListBankAccountsResponse.Warning);
/**
 * SOURCE Code @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 42:5
 */
ListBankAccountsResponse.Warning.Code = $root.lookupEnum('squareup.bankingaccounts.external.service.ListBankAccountsResponse.Warning.Code').values;
/**
 * SOURCE Category @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 52:5
 */
ListBankAccountsResponse.Warning.Category = $root.lookupEnum('squareup.bankingaccounts.external.service.ListBankAccountsResponse.Warning.Category').values;
/**
 * SOURCE CreateDepositBankAccountRequest @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 60:1
 */
export const CreateDepositBankAccountRequest = $root.lookupType('squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest');
fixType(CreateDepositBankAccountRequest, {
  idempotenceKey: {
    notEmpty: true
  },
  squareTokenAssociation: {
    required: true
  }
});
Builder.createAndAttachToType(CreateDepositBankAccountRequest);
/**
 * SOURCE UsSavingsParams @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 75:3
 */
CreateDepositBankAccountRequest.UsSavingsParams = $root.lookupType('squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest.UsSavingsParams');
fixType(CreateDepositBankAccountRequest.UsSavingsParams);
Builder.createAndAttachToType(CreateDepositBankAccountRequest.UsSavingsParams);
/**
 * SOURCE UsCheckingParams @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 80:3
 */
CreateDepositBankAccountRequest.UsCheckingParams = $root.lookupType('squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest.UsCheckingParams');
fixType(CreateDepositBankAccountRequest.UsCheckingParams);
Builder.createAndAttachToType(CreateDepositBankAccountRequest.UsCheckingParams);
/**
 * SOURCE CaFoldersParams @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 84:3
 */
CreateDepositBankAccountRequest.CaFoldersParams = $root.lookupType('squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest.CaFoldersParams');
fixType(CreateDepositBankAccountRequest.CaFoldersParams);
Builder.createAndAttachToType(CreateDepositBankAccountRequest.CaFoldersParams);
/**
 * SOURCE CaSquareCardParams @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 88:3
 */
CreateDepositBankAccountRequest.CaSquareCardParams = $root.lookupType('squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest.CaSquareCardParams');
fixType(CreateDepositBankAccountRequest.CaSquareCardParams);
Builder.createAndAttachToType(CreateDepositBankAccountRequest.CaSquareCardParams);
/**
 * SOURCE GbSquareCardParams @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 94:3
 */
CreateDepositBankAccountRequest.GbSquareCardParams = $root.lookupType('squareup.bankingaccounts.external.service.CreateDepositBankAccountRequest.GbSquareCardParams');
fixType(CreateDepositBankAccountRequest.GbSquareCardParams);
Builder.createAndAttachToType(CreateDepositBankAccountRequest.GbSquareCardParams);
/**
 * SOURCE CreateDepositBankAccountResponse @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 101:1
 */
export const CreateDepositBankAccountResponse = $root.lookupType('squareup.bankingaccounts.external.service.CreateDepositBankAccountResponse');
fixType(CreateDepositBankAccountResponse);
Builder.createAndAttachToType(CreateDepositBankAccountResponse);
/**
 * SOURCE Success @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 107:3
 */
CreateDepositBankAccountResponse.Success = $root.lookupType('squareup.bankingaccounts.external.service.CreateDepositBankAccountResponse.Success');
fixType(CreateDepositBankAccountResponse.Success);
Builder.createAndAttachToType(CreateDepositBankAccountResponse.Success);
/**
 * SOURCE Error @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 112:3
 */
CreateDepositBankAccountResponse.Error = $root.lookupType('squareup.bankingaccounts.external.service.CreateDepositBankAccountResponse.Error');
fixType(CreateDepositBankAccountResponse.Error);
Builder.createAndAttachToType(CreateDepositBankAccountResponse.Error);
/**
 * SOURCE Code @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 117:5
 */
CreateDepositBankAccountResponse.Error.Code = $root.lookupEnum('squareup.bankingaccounts.external.service.CreateDepositBankAccountResponse.Error.Code').values;
/**
 * SOURCE Category @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 135:5
 */
CreateDepositBankAccountResponse.Error.Category = $root.lookupEnum('squareup.bankingaccounts.external.service.CreateDepositBankAccountResponse.Error.Category').values;
/**
 * SOURCE GetBankAccountRequest @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 144:1
 */
export const GetBankAccountRequest = $root.lookupType('squareup.bankingaccounts.external.service.GetBankAccountRequest');
fixType(GetBankAccountRequest);
Builder.createAndAttachToType(GetBankAccountRequest);
/**
 * SOURCE GetBankAccountResponse @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 157:1
 */
export const GetBankAccountResponse = $root.lookupType('squareup.bankingaccounts.external.service.GetBankAccountResponse');
fixType(GetBankAccountResponse);
Builder.createAndAttachToType(GetBankAccountResponse);
/**
 * SOURCE Error @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 163:3
 */
GetBankAccountResponse.Error = $root.lookupType('squareup.bankingaccounts.external.service.GetBankAccountResponse.Error');
fixType(GetBankAccountResponse.Error);
Builder.createAndAttachToType(GetBankAccountResponse.Error);
/**
 * SOURCE Code @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 167:5
 */
GetBankAccountResponse.Error.Code = $root.lookupEnum('squareup.bankingaccounts.external.service.GetBankAccountResponse.Error.Code').values;
/**
 * SOURCE Category @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 177:5
 */
GetBankAccountResponse.Error.Category = $root.lookupEnum('squareup.bankingaccounts.external.service.GetBankAccountResponse.Error.Category').values;
/**
 * SOURCE GetActiveBankAccountForUnitRequest @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 185:1
 */
export const GetActiveBankAccountForUnitRequest = $root.lookupType('squareup.bankingaccounts.external.service.GetActiveBankAccountForUnitRequest');
fixType(GetActiveBankAccountForUnitRequest, {
  squareTokenAssociation: {
    required: true
  }
});
Builder.createAndAttachToType(GetActiveBankAccountForUnitRequest);
/**
 * SOURCE GetActiveBankAccountForUnitResponse @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 195:1
 */
export const GetActiveBankAccountForUnitResponse = $root.lookupType('squareup.bankingaccounts.external.service.GetActiveBankAccountForUnitResponse');
fixType(GetActiveBankAccountForUnitResponse);
Builder.createAndAttachToType(GetActiveBankAccountForUnitResponse);
/**
 * SOURCE Error @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 201:3
 */
GetActiveBankAccountForUnitResponse.Error = $root.lookupType('squareup.bankingaccounts.external.service.GetActiveBankAccountForUnitResponse.Error');
fixType(GetActiveBankAccountForUnitResponse.Error);
Builder.createAndAttachToType(GetActiveBankAccountForUnitResponse.Error);
/**
 * SOURCE Code @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 205:5
 */
GetActiveBankAccountForUnitResponse.Error.Code = $root.lookupEnum('squareup.bankingaccounts.external.service.GetActiveBankAccountForUnitResponse.Error.Code').values;
/**
 * SOURCE Category @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 212:5
 */
GetActiveBankAccountForUnitResponse.Error.Category = $root.lookupEnum('squareup.bankingaccounts.external.service.GetActiveBankAccountForUnitResponse.Error.Category').values;
/**
 * SOURCE CloseDepositBankAccountRequest @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 220:1
 */
export const CloseDepositBankAccountRequest = $root.lookupType('squareup.bankingaccounts.external.service.CloseDepositBankAccountRequest');
fixType(CloseDepositBankAccountRequest, {
  accountId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CloseDepositBankAccountRequest);
/**
 * SOURCE CloseDepositBankAccountResponse @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 226:1
 */
export const CloseDepositBankAccountResponse = $root.lookupType('squareup.bankingaccounts.external.service.CloseDepositBankAccountResponse');
fixType(CloseDepositBankAccountResponse);
Builder.createAndAttachToType(CloseDepositBankAccountResponse);
/**
 * SOURCE Error @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 234:3
 */
CloseDepositBankAccountResponse.Error = $root.lookupType('squareup.bankingaccounts.external.service.CloseDepositBankAccountResponse.Error');
fixType(CloseDepositBankAccountResponse.Error);
Builder.createAndAttachToType(CloseDepositBankAccountResponse.Error);
/**
 * SOURCE Code @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 239:5
 */
CloseDepositBankAccountResponse.Error.Code = $root.lookupEnum('squareup.bankingaccounts.external.service.CloseDepositBankAccountResponse.Error.Code').values;
/**
 * SOURCE Category @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 244:5
 */
CloseDepositBankAccountResponse.Error.Category = $root.lookupEnum('squareup.bankingaccounts.external.service.CloseDepositBankAccountResponse.Error.Category').values;
/**
 * SOURCE BankAccountsServiceExternal @ squareup/bankingaccounts/external/external_bank_accounts_service.proto at 252:1
 */
export const BankAccountsServiceExternal = $root.lookupService('squareup.bankingaccounts.external.service.BankAccountsServiceExternal');